<template>
	<div class="topUps">
		<div class="topUps_head">
			<span class="ups_left">余额明细</span>
			<span class="ups_right" @click="close('yemx')">关闭</span>
		</div>
		<div  class="upsBox"  @scroll.passive="getScroll($event)">
			  <div class="infinite-list-wrapper"  >
			    <ul>
					<li  v-for="item  in info">
							<div class="infobox">
								<div class="top">
									<div class="order">
										<span class="leftorder">
											订单号：{{item.trade_no}}
										</span>
										<span class="rightorder">
											{{item.update_time}}
										</span>
									</div>
								</div>
								
								<div class="top">
									<div class="order">
										<span class="leftorder">
											{{item.bal_no}}
										</span>
										<span class="rightorder">
											{{item.bal_amt}}
										</span>
									</div>
								</div>
							</div>   						
					</li>
			    </ul>
			    <p v-if="loading" style="text-align: center;line-height: 40px;">加载中...</p>
			    <p v-else="loading" style="text-align: center;line-height: 40px;">没有更多了</p>
			  </div>
		</div>
	</div>
</template>

<script>
import qs from "qs"	
export default {	
	props:['chongzhi'],
  data () {
    return {
    	qunData:[],
		memberData:[],
		topUps:'***',
		is_last: 1,
        loading: true,
        info:[],
        finished:true,
        pageNo:1,
		 
    }
  },
	computed: {
	  noMore () {
	    return this.is_last == '1'
	  },
	  disabled () {
	    return false
	  }
	},  
  methods:{
  	close(data){
  		 if (this.chongzhi) {
          this.chongzhi(data);
        }
  	},
  	getInfo(){	
		let params = qs.stringify({
				pageNo:this.pageNo,
				pageSize:15
		})  		
		this.$axios.defaults.headers.common['token'] = this.getCookie("mytokenIm")
			this.$axios.post('/goods/account/v1/balance_detail',params)
			.then(userData=>{
				if(userData.data.resultCode=='0000'){
					this.is_last=userData.data.resultInfo.is_last
					this.info=this.info.concat(userData.data.resultInfo.list)
					if(userData.data.resultInfo.is_last=='1'){
						this.finished=true
						this.loading=true
					}else{
						this.finished=false
						this.loading=false
					}
				}else{
					this.finished=true
					this.loading=true
					this.$message.error(userData.data.resultMsg);
				}	
			}).catch(error=>{
				console.log(error)
			})  		
  	},
	getScroll(event) {
      let scrollBottom =event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight;
       if (this.finished && scrollBottom < 40) {
       		this.finished=false
        	this.pageNo=this.pageNo+1
    	    this.getInfo()
       }
    },  	
	getCookie(c_name){
	//判断document.cookie对象里面是否存有cookie
	if (document.cookie.length>0){
	  var c_start=document.cookie.indexOf(c_name + "=")
		//如果document.cookie对象里面有cookie则查找是否有指定的cookie，如果有则返回指定的cookie值，如果没有则返回空字符串
	  if (c_start!=-1){ 
	    c_start=c_start + c_name.length+1 
	   var c_end=document.cookie.indexOf(";",c_start)
	    if (c_end==-1) c_end=document.cookie.length
	     return unescape(unescape(document.cookie.substring(c_start,c_end)))
	    } 
	  }
	return ""
	},		  
  },
  created:function(){
  		this.getInfo()
  },
}	
</script>

<style scoped>
.topUps{
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	background: #FFFFFF;
	z-index: 1000;
	overflow: auto;
	padding-top: 40px;
}
.topUps_head{
	background: #F2F6FC;
	position: absolute;
	width: 100%;
	left: 0;
	top: 0;
	line-height: 40px;
	padding: 0px 15px;
	overflow: hidden;
}
.ups_left{
	float: left;
	font-weight: bold;
}
.ups_right{
	float: right;
	color: red;
	cursor: pointer;
}
.upsBox{
	width: 100%;
	height: 100%;
	overflow: auto;
}
.dianchi{
	
}
.dianchi ul{
	overflow: hidden;
	padding-top: 15px;
}
.dianchi ul li{
	text-align: center;
	float: left;
	width: 33.33333%;
	padding: 15px 0px;
	cursor: pointer;
}
.dianchi ul li:hover{
	background: #F2F6FC;
}
.dianchi ul li i{
	display: block;
	margin: auto;
	font-size: 60px;
	color: #666666;
}
.dianchi ul li span{
	display: block;
	margin: auto;
	color: #666666;
	height: 20px;
	line-height: 20px;
	font-size: 12px;
}

.dianchi ul li p{
	display: block;
	margin: auto;
	color: red;
}
.infobox{
	padding: 10px 15px;
	border-bottom: 1px solid #DFDFDF;
}
.infobox .top{
	padding-bottom: 10px;
}
.infobox .top .order{
	overflow: hidden;
	
}
.infobox .top .leftorder{
	float: left;
	font-size: 14px;
}
.infobox .top .rightorder{
	float: right;
	font-size: 14px;
	color: red;
}

</style>


// WEBPACK FOOTER //
// src/components/im/topUpsYEMX.vue